import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReportsAbstractService } from './reports-abstract.service';

@Injectable()
export class OrderOptionsReportService extends ReportsAbstractService {
  public reportRoute: string = 'order_options_report';

  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }
}
